import NotificationButton from './NotificationButton';

const DashboardHeader = ({ user, onToggleSidebar }) => {
  const userImage = user?.photoUrl || user?.imgInstructor || "";

  return (
    <nav className="navbar navbar-light bg-light shadow-sm fixed-top p-2">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <button
          className="btn btn-outline-secondary d-md-none me-2"
          type="button"
          onClick={onToggleSidebar}
          aria-label="Toggle navigation"
        >
          <i className="fas fa-bars"></i>
        </button>

        <div className="d-flex align-items-center">
          {userImage ? (
            <img
              src={userImage}
              alt="Usuario"
              className="rounded-circle me-2"
              width="40"
              height="40"
              style={{ objectFit: "cover" }}
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          ) : (
            <div
              className="rounded-circle me-2 bg-secondary d-flex align-items-center justify-content-center text-white"
              style={{ width: 40, height: 40 }}
            >
              <i className="fa-solid fa-user"></i>
            </div>
          )}

          <span className="fw-bold">
            {user?.name || user?.nombreInstructor || "Usuario"}
          </span>
        </div>

        <NotificationButton />
      </div>
    </nav>
  );
};

export default DashboardHeader;